import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-clipped-note',
  templateUrl: './clipped-note.component.html',
  styleUrls: ['./clipped-note.component.scss']
})
export class ClippedNoteComponent  {
  @Input() text: string;
  @Input() showFullText = false;
  @Output() showFullTextChange = new EventEmitter<boolean>();

  constructor() { }


  setShowFullText(value: boolean) {
    this.showFullText = value;
    this.showFullTextChange.emit(this.showFullText);
  }

}
